import { call, put } from 'redux-saga/effects';
import API from './apis';
import { getSliderImagesSuccess, getSliderImagesFailure } from './action';
import { takeLatest } from 'redux-saga/effects';
import TYPES from './types';

export function* getSliderImagesSaga() {
    try {
        const response = yield call(API.getSliderImages);
        yield put(getSliderImagesSuccess(response.data));
    } catch (err) {
        yield put(getSliderImagesFailure(err?.data));
    }
}

export function* Saga() {
    yield takeLatest(TYPES.GET_SLIDER_IMAGES, getSliderImagesSaga);
}
